module.exports = __webpack_public_path__ + "img/devops.e263971.svg";